// assets
import AltRouteIcon from '@mui/icons-material/AltRoute';
import AutoFixHigh from '@mui/icons-material/AutoFixHigh';
import CampaignIcon from '@mui/icons-material/Campaign';
import DynamicForm from '@mui/icons-material/DynamicForm';
import EmailIcon from '@mui/icons-material/Email';
import GroupsIcon from '@mui/icons-material/Groups';
import ImageIcon from '@mui/icons-material/Image';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import SendIcon from '@mui/icons-material/Send';

// type
import ERoutes from 'routes/ERoutes';
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - COMMUNICATIONS ||============================== //

const communications: NavItemType = {
    id: 'communications',
    title: 'Communications',
    icon: CampaignIcon,
    type: 'group',
    // Gate the whole Communications group so Developer never sees the menu; the
    // sidebar only hides a top-level group when the group itself carries `roles`.
    roles: ['superAdmin', 'customerService'],
    url: ERoutes.crmJourney,
    children: [
        {
            id: 'crm-journey',
            title: 'Customer journey',
            type: 'item',
            icon: AltRouteIcon,
            url: ERoutes.crmJourney,
            breadcrumbs: false
        },
        {
            id: 'crm-campaigns',
            title: 'Campaigns',
            type: 'item',
            icon: SendIcon,
            url: ERoutes.crmCampaigns,
            breadcrumbs: false
        },
        {
            id: 'email-template',
            title: 'Automated emails',
            type: 'item',
            icon: MarkEmailReadIcon,
            url: '/email-template/list',
            breadcrumbs: false
        },
        {
            id: 'crm-automations',
            title: 'Automations',
            type: 'item',
            icon: AutoFixHigh,
            url: ERoutes.crmAutomations,
            breadcrumbs: false
        },
        {
            id: 'crm-audiences',
            title: 'Audiences',
            type: 'item',
            icon: GroupsIcon,
            url: ERoutes.crmAudiences,
            breadcrumbs: false
        },
        {
            id: 'crm-email-templates',
            title: 'Email templates',
            type: 'item',
            icon: EmailIcon,
            url: ERoutes.crmEmailTemplates,
            breadcrumbs: false
        },
        {
            id: 'crm-forms',
            title: 'Forms',
            type: 'item',
            icon: DynamicForm,
            url: ERoutes.crmForms,
            breadcrumbs: false
        },
        {
            id: 'image-assets',
            title: 'Image assets',
            type: 'item',
            icon: ImageIcon,
            url: ERoutes.imageAssets,
            breadcrumbs: false
        }
    ]
};

export default communications;
